const THEME_STORAGE_KEY = "docchoice-color-theme";

export const THEME_LIGHT = "light";
export const THEME_DARK = "dark";

export function getStoredTheme() {
  if (typeof window === "undefined") {
    return THEME_LIGHT;
  }
  const stored = localStorage.getItem(THEME_STORAGE_KEY);
  if (stored === THEME_DARK || stored === THEME_LIGHT) {
    return stored;
  }
  if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
    return THEME_DARK;
  }
  return THEME_LIGHT;
}

export function applyTheme(theme) {
  const next = theme === THEME_DARK ? THEME_DARK : THEME_LIGHT;
  document.documentElement.setAttribute("data-theme", next);
  localStorage.setItem(THEME_STORAGE_KEY, next);
  return next;
}

export function initTheme() {
  return applyTheme(getStoredTheme());
}

export function toggleTheme() {
  const current = document.documentElement.getAttribute("data-theme") || getStoredTheme();
  return applyTheme(current === THEME_DARK ? THEME_LIGHT : THEME_DARK);
}
